export default {"src":"/_next/static/media/logo_wh.95aa3602.svg","height":39,"width":191,"blurWidth":0,"blurHeight":0};